import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}
export { OzBasePopoverColors as OzPopoverColors } from '@@/library/v4/components/OzBasePopover.vue'

import OzBasePopover, { OzBasePopoverColors, type Anchor } from '@@/library/v4/components/OzBasePopover.vue'
import OzOverlay from '@@/library/v4/components/OzOverlay.vue'
import type { ComputePositionConfig } from '@floating-ui/vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzPopover',
  props: {
    anchor: null,
    config: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    xScrim: { type: Boolean, default: true },
    isModal: { type: Boolean, default: true },
    shouldFadeIn: { type: Boolean, default: false },
    radius: { default: 20 },
    color: { default: OzBasePopoverColors.PrimaryBlur },
    boxClasses: { default: undefined }
  },
  emits: ["scrim-click", "scrim-esc"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'scrim-click'): void
  (name: 'scrim-esc'): void
}), expose: any, slots: any, attrs: any }) {





const scrimClick = (): void => emit('scrim-click')
const scrimEsc = (): void => emit('scrim-esc')

return { __sfc: true,emit, scrimClick, scrimEsc, OzBasePopover, OzOverlay }
}

})